
import { useEffect } from 'react'
import Select from 'react-select'
import { ParameterTypeDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const STPParameterTypeDataDDL = (props) => {
    const { ParameterType, setParameterType, IsPost } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_UserID: UserID,
            token: token,
        }
        // if (UnitType.ID) {
        dispatch(ParameterTypeDDLAPI({ data }))
        // }
    }, [IsPost])

    const { ParameterTypeData } = useSelector(state => state.ParameterTypeDDL)

    useEffect(() => {
        handleSTPParameterTypeDDL()
    }, [ParameterTypeData])

    const handleSTPParameterTypeDDL = () => {
        // console.log(DeptDDLDataa)
        if (ParameterTypeData && ParameterTypeData.table && ParameterTypeData.table.length > 0) {
            let list = ParameterTypeData.table.map((item, index) => ({
                value: item.m_IndicatorID,
                label: item.indicatorName,
            }))

            // setEmployeeDDL({
            //     DDL: list,
            //     ID: Flag === 'Update' ? rowData.m_EmployeeID : 0,
            //     Label: Flag === 'Update' ? rowData.employeeName : "Select...",
            // })
            setParameterType({ ...ParameterType, DDL: list })
        }
        else {
            setParameterType({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }
    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Parameter Type </b></label>
            <Select
                // isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: ParameterType.ID, label: ParameterType.Label }}
                onChange={(e) => {
                    e ?
                        setParameterType({ ...ParameterType, ID: e.value, Label: e.label })
                        :
                        setParameterType({ ...ParameterType, ID: 0, Label: "Select..." })

                }}
                options={ParameterType.DDL}
            />
        </div>
    )
}